export enum RagEnvironments {
  dev = "dev",
  prod = "prod",
}
export const RAG_ENDPOINT_KEY = "ragEndpoint";
const DEV_URL =
  "https://e6jx63sg6mqz5sgw4mpd57khvy0jreju.lambda-url.us-east-1.on.aws/";
const PROD_URL =
  "https://bf5i7ox6qgmpgygkfs74bovbp40knpfa.lambda-url.us-east-1.on.aws/";
const environmentUrls = {
  [RagEnvironments.dev]: DEV_URL,
  [RagEnvironments.prod]: PROD_URL,
};

export function getEndpointUrl(endpoint: string) {
  return environmentUrls[endpoint] || endpoint;
}

export function getRagEndpoint() {
  //url hash
  const host = window.location.hostname;
  const hash = window.location.hash?.slice(1);
  const hostFromHash = hash?.startsWith("host:");
  if (hostFromHash) {
    const hostVal = hash.slice("host:".length);
    console.log("hostFromHash", hostVal);
    return hostVal;
  }

  //local storage
  const endpoint = localStorage.getItem(RAG_ENDPOINT_KEY);
  if (endpoint) return endpoint;

  //identify the environment based on the host
  switch (host) {
    case "localhost":
    case "dialogue-dev.kahun.com":
    case "develop.kahun.com":
      return RagEnvironments.dev;
    case "dialogue.kahun.com":
    case "diagnose.kahun.com":
    case "staging.kahun.com":
      return RagEnvironments.prod;
    default:
      return RagEnvironments.prod;
  }
}
